const NON_STRING_TYPES = new Set([
  'number',
  'datetime',
  'boolean',
  'deviceType',
  'referrerType',
]);

function dimensionSupportsIgnoreCasing(dimension) {
  if (!dimension || dimension.unique) {
    return false;
  }
  return !NON_STRING_TYPES.has(dimension.type);
}

function dimensionIgnoresCasing(dimension) {
  return Boolean(dimension?.ignoreCasing || dimension?.transforms?.includes('lowerCase'));
}

function withIgnoreDimensionCasing(dimensions, enabled, overrides) {
  if (!enabled && !overrides) {
    return dimensions || [];
  }
  return (dimensions || []).map((dimension) => {
    if (!dimensionSupportsIgnoreCasing(dimension)) {
      return dimension;
    }
    const ignoreCasing = overrides?.[dimension.name] ?? Boolean(enabled || dimension.ignoreCasing);
    return ignoreCasing === Boolean(dimension.ignoreCasing) ? dimension : { ...dimension, ignoreCasing };
  });
}

function lowercaseFilterValue(value) {
  if (typeof value === 'string') {
    return value.toLowerCase();
  }
  if (Array.isArray(value)) {
    return value.map(lowercaseFilterValue);
  }
  return value;
}

module.exports = {
  dimensionSupportsIgnoreCasing,
  dimensionIgnoresCasing,
  withIgnoreDimensionCasing,
  lowercaseFilterValue,
};
